import ApiService from '@/services/ApiService';

const BASE_URI = '/promotion';

export default {
  list() {
    return ApiService().get(`${BASE_URI}/list`);
  },
};
